import { loadStripe, StripeError } from "@stripe/stripe-js";

export const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

export const redirectToStripeCheckout = async (sessionId: string): Promise<{ error: StripeError }> => {
  const stripe = await stripePromise;
  return stripe.redirectToCheckout({ sessionId });
};
